import type { CampaignStatus, CampaignSummary } from "../../shared/contracts";

export const JA_JP_LOCALE = "ja-JP";
export const JAPAN_TIME_ZONE = "Asia/Tokyo";

export const jaJP = {
  verificationBadge: "公式確認済み",
  purchaseService: "掲載・PRサービス",
  settledBidAmount: "決済済み入札額",
  campaignAdvertisingAllocation: "キャンペーン広告配分",
} as const;

export const promotionStatusLabels: Record<CampaignSummary["promotionStatus"], string> = {
  not_eligible: "利用条件未達",
  available: "利用可能",
  planning: "企画中",
  approved: "実施承認済み",
  fulfilled: "実施完了",
  overdue: "対応期限超過",
};

export const campaignStatusLabels: Record<CampaignStatus, string> = {
  nomination: "非公開リクエスト",
  pending: "確認中",
  active: "公開中",
  paused: "受付停止中",
  withdrawn: "掲載終了",
  suspended: "利用停止中",
};

export function getCampaignStatusLabel(status: string): string {
  return campaignStatusLabels[status as CampaignStatus] ?? status;
}

export function formatJapanDate(value: string): string {
  return new Intl.DateTimeFormat(JA_JP_LOCALE, { timeZone: JAPAN_TIME_ZONE, year: "numeric", month: "numeric", day: "numeric" }).format(new Date(value));
}

export function formatJapanDateTime(value: string): string {
  return new Intl.DateTimeFormat(JA_JP_LOCALE, { timeZone: JAPAN_TIME_ZONE, year: "numeric", month: "numeric", day: "numeric", hour: "2-digit", minute: "2-digit" }).format(new Date(value));
}

export function formatRelativeJapanese(value: string | null, now = new Date()): string {
  if (!value) return "入札なし";
  const date = new Date(value);
  const elapsedMs = now.getTime() - date.getTime();
  if (!Number.isFinite(elapsedMs)) return "入札なし";
  if (elapsedMs < 60_000) return "たった今";
  if (elapsedMs < 60 * 60_000) return `${Math.floor(elapsedMs / 60_000)}分前`;
  if (elapsedMs < 24 * 60 * 60_000) return `${Math.floor(elapsedMs / (60 * 60_000))}時間前`;
  if (elapsedMs < 48 * 60 * 60_000) return "昨日";
  return new Intl.DateTimeFormat(JA_JP_LOCALE, { timeZone: JAPAN_TIME_ZONE, month: "numeric", day: "numeric" }).format(date);
}
